import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import { PieChart } from "@mui/x-charts/PieChart";
import { theme } from "../../themes/theme";

interface ProgressPieChartProp {
  total: number;
  highlighted: number;
  completed: number;
  modal: boolean;
}

const ProgressPieChart: React.FC<ProgressPieChartProp> = (prop) => {
  const [markedCount, setMarkedCount] = useState<number>(prop.completed);
  const [highlightedCount, setHighlightedCount] = useState<number>(prop.highlighted);
  const [unMarkedCount, setUnMarkedCount] = useState<number>(
    prop.total - prop.completed - prop.highlighted
  );

  useEffect(() => {
    if (prop.total === 0 && prop.completed === 0 && prop.highlighted === 0) {
      // if no alerts assigned, display fully circle and tick
      setMarkedCount(100);
      setHighlightedCount(0);
      setUnMarkedCount(0);
    }
  }, []);

  return (
    <Box sx={{ width: "100%", display: "flex", justifyContent: "center" }}>
      <PieChart
        tooltip={{ trigger: "none" }}
        series={[
          {
            data: [
              { id: 0, value: markedCount, color: theme.table.pieChartCompletedColor },
              { id: 1, value: unMarkedCount, color: theme.table.pieChartUncompletedColor },
              { id: 2, value: highlightedCount, color: theme.table.pieChartHighlightedColor },
            ],
            innerRadius: prop.modal ? 40 : 14,
            outerRadius: prop.modal ? 30 : 20,
            paddingAngle: 0,
            cornerRadius: 3,
            cx: prop.modal ? 50 : 20,
            cy: prop.modal ? 60 : 19,
          },
        ]}
        height={prop.modal ? 120 : 50}
        width={prop.modal ? 120 : 50}
      />
      {prop.completed === prop.total && (
        <Box sx={{ position: "absolute", mt: 1.6 }}>
          <CheckIcon
            sx={{
              mt: prop.modal ? 3 : 0,
              mr: prop.modal ? 1 : 0,
              height: prop.modal ? "50px" : "26px",
              width: prop.modal ? "50px" : "26px",
              strokeWidth: 2,
              stroke: theme.table.pieChartCompletedColor,
              color: theme.table.pieChartCompletedColor,
            }}
          />
        </Box>
      )}
    </Box>
  );
};

export default ProgressPieChart;
